import { render } from "./clientForm.vue?vue&type=template&id=27f884a2&scoped=true"
import script from "./clientForm.vue?vue&type=script&lang=js"
export * from "./clientForm.vue?vue&type=script&lang=js"

import "./clientForm.vue?vue&type=style&index=0&id=27f884a2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f884a2"]])

export default __exports__